<template>
  <div>
    <b-card-actions
      v-if="status_key === 'key_11'"
      title="Sorting"
      action-collapse
      collapsed
    >
      <b-row>
        <!--Freeze Warehouse dropdown-->
        <b-col
          cols="6"
          :md="3"
        >
          <b-form-group
            label="Current Warehouse"
            label-for="current-Warehouse"
          >
            <v-select
              id="current-Warehouse"
              v-model="filters['destination_warehouse']"
              :options="assignedwarehouse"
              :reduce="option => option.id"
              label="name"
              placeholder="Select Warehouse"
              :disabled="freezeWarehouseCheckbox"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
          <!--checkbox-->
          <div class="mt-1">
            <b-form-checkbox
              v-model="freezeWarehouseCheckbox"
              :disabled="!isFreezeWarehouseSelected()"
            >
              Freeze Warehouse
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card>
      <b-row>
        <b-col>
          <form-builder
            ref="formbuilder"
            v-model="formData"
            :on-submit="onSubmit"
            grid-class="px-1 row"
            :form-structure="formStructure"
            @waybillPaste="handleWaybillPaste"
            @waybillScan="getScanOrderDetails"
          >
            <template
              v-if="isProofKey"
              slot="buttons"
            >
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  label-for="proof_images"
                  description="Up to 4 images per status, ≤ 5 MB each (jpeg/png/webp)."
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center w-100">
                      <span>Proof Images</span>
                      <small class="text-muted">({{ uploadedImages.length }}/{{ MAX_IMAGES }})</small>
                    </div>
                  </template>
                  <b-form-file
                    ref="proof_images"
                    multiple
                    :disabled="uploadedImages.length >= MAX_IMAGES"
                    accept="image/jpeg,image/png,image/webp"
                    browse-text="Choose File"
                    :placeholder="uploadedImages.length ? `${uploadedImages.length} file${uploadedImages.length === 1 ? '' : 's'} selected` : 'No file chosen'"
                    class="w-100"
                    @change="onSelectFiles"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="uploadedImages.length"
                cols="12"
                class="mt-1"
              >
                <div class="uploader-grid mb-1">
                  <div
                    v-for="(img, idx) in uploadedImages"
                    :key="img.localId"
                    class="uploader-card"
                  >
                    <img
                      :src="img.preview"
                      alt=""
                      class="uploader-img"
                    >
                    <button
                      type="button"
                      class="uploader-remove"
                      aria-label="Remove"
                      @click.stop="removeImage(idx)"
                    >
                      ×
                    </button>
                  </div>
                </div>
              </b-col>
              <b-col
                cols="12"
                md="auto"
              >
                <b-button
                  type="submit"
                  class="vh-5 mt-2 ml-0 ml-md-1 custom-button-color w-100"
                  :disabled="!(formData.waybill_number) || loadingResponse"
                >
                  {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                </b-button>
              </b-col>

            </template>
            <template
              v-else
              slot="buttons"
            >
              <b-row>
                <b-col>
                  <b-button
                    type="submit"
                    class="vh-5 mt-2 ml-1 ml-md-1 custom-button-color"
                    :disabled="!(formData.waybill_number) || loadingResponse"
                  >
                    {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <template
              v-if="status_key === 'key_19'"
              slot="flag"
            >
              <b-col
                cols="3"
                :md="3"
                class="mt-2 ml-2  align-items-end"
              >
                <span
                  v-for="status in flagData.order_flags"
                  :key="status"
                >
                  <span
                    v-if="status === 'Redelivery'"
                    :class="{ 'red-text': status === 'Redelivery' }"
                  >
                    <div class="alert-body">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="outline-info"
                      >
                        <feather-icon
                          icon="RotateCwIcon"
                          class="mr-50"
                        />
                        <span class="align-middle">Redelivery</span>
                      </b-button>
                    </div>
                  </span>
                </span>
              </b-col>
            </template>
          </form-builder>
          <div class="d-flex flex-wrap align-items-center mr-1 ml-1">
            <b-col
              cols="12"
              md="auto"
              class="p-0"
            >
              <b-form-checkbox
                v-model="auto_submit"
                :value="true"
                class="mt-2 mt-md-0 ml-0"
              >
                <small>Auto Submit</small>
              </b-form-checkbox>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            :label="date_filter_name"
            label-for="basicInput"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters[date_filter_key]"
                :opens="'right'"
                @update="updateDateRange(date_filter_key, $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          v-if="status_key === 'key_13'"
          cols="12"
          md="3"
        >
          <b-form-group
            label="Rider"
            label-for="rider"
          >
            <v-select
              v-model="filters['rider']"
              :options="riderOptions"
              :reduce="option => option.id"
              label="first_name"
              placeholder="Select Rider"
            >
              <template v-slot:option="option">
                {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          v-if="status_key === 'key_19' || status_key === 'key_28' || status_key === 'key_27'"
          cols="12"
          md="3"
        >
          <b-form-group
            label="Merchant"
            label-for="v-ref-no"
          >
            <v-select
              id="v-ref-no"
              v-model="filters['merchant_id']"
              :options="merchantOptions"
              :reduce="option => option.id"
              label="name"
              placeholder="Select Merchant"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </FilterCard>
    <b-card no-body>
      <div class="m-2">
        <b-row cols="12">
          <b-col
            md="4"
            lg="4"
            class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
          >
            <bulk-submit
              :status-key="status_key"
              :selected-waybills="selectedWaybillArray"
              @bulkSubmit="onClickBulkAction"
            />
          </b-col>
          <b-col
            md="4"

            class="d-flex align-items-center justify-content-center mb-1 mb-md-0"
          >
            <b-button
              type="submit"
              class="custom-button-color-blur"
              :disabled="false"
            >
              Scanned Orders : {{ submitCount }}
            </b-button>
          </b-col>
          <b-col
            md="4"

            class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
          >
            <ReportTableButtons
              :items="rows"
              :json_fieldz="json_fields"
              :name="`${status_name} - Page ${page}.xls`"
              :bulkname="`${status_name}.xls`"
              :fetch="getOrderListNoPagination"
              @refresh="onClickRefresh"
            />
          </b-col>
        </b-row>
        <b-row>
          <div class="font-weight-bolder text-muted ml-1 mt-1">
            {{ `${selectedWaybillArray.length} record${selectedWaybillArray.length === 1 ? '':'s'}` }} selected
          </div>
        </b-row>
      </div>

      <b-row>
        <b-col>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              show-empty
              sticky-header="100vh"
              class="hide-vertical-scroll"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #head(id)>
                <div class="d-flex align-items-start">
                  <div>
                    <b-form-checkbox
                      id="selectAllCheckbox"
                      v-model="selectAllCheckbox"
                      name="selectAllCheckbox"
                      @change="onClickSelectAllCheckbox()"
                    />
                  </div>
                </div>
              </template>
              <template #cell(id)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="font-weight-bolder">
                      <b-form-checkbox
                        v-model="selectedWaybillArray"
                        :value="data.item.waybill_number"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.item.customer_name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      :class="{'font-weight-bolder ml-1 text-danger': data.item.temporary_warehouse_id !=null ,'font-weight-bolder ml-1 text-primary':data.item.temporary_warehouse_id ===null}"
                      @click="onClickViewOrderModal(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.name)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="">
                      {{ __orderMerchantName(data.item) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.item.customer_name }}
                    </div>
                    <div class="font-small-2">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                    <div class="font-small-2">
                      {{ data.item.customer_address }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(origin_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.origin_city.name }}
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(destination_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.destination_city.name }}
                      <!--                    </b-badge>-->
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(rider_name)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ `${data.item.rider.first_name} ${data.item.rider.last_name || ''}` }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider.email }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider && data.item.rider.reference_id ? data.item.rider.reference_id : '' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(finance)="data">
                <div
                  v-if="__getMerchantType(data.item) !== 'WC'"
                  class="width-150"
                >
                  <b>Total&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.cod, true) || '---' }}
                  <div style="height:8px;" />
                  <b>Collected&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                </div>
                <div
                  v-else
                  class="width-150"
                >
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                  <div style="height:8px;" />
                  <b>Advance&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>Balance&nbsp;:</b>&nbsp;&nbsp;{{ (data.item.delivery_charge - data.item.collected_cod ) || '---' }}
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>

              <!-- ... Flag Componant ... -->
              <template #cell(order_flags)="data">
                <div class="d-flex align-items-center">
                  <FlagDisplay :flags="data.item.order_flags" />
                </div>
              </template>

              <template #cell(status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    @click="onClickViewOrderModal(data.item.id)"
                  >
                    <feather-icon icon="EyeIcon" />
                    View
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-overlay>
          <div class="mx-2 mb-2">
            <b-row
              cols="12"
            >
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <bulk-action-modal
      ref="bulkActionModal"
      :form_structure="formStructure"
      :status_key="status_key"
      :selected_waybill_array="selectedWaybillArray"
      :rows="rows"
    />
    <view-order-modal ref="viewOrderModal" />
  </div>
</template>

<script>
import {
  BAvatar,
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BFormGroup,
  BPagination,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  VBTooltip,
  BFormFile,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'
import store from '@/store'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
import FlagDisplay from '@/components/AllOrders/OrderFlags/FlagDisplay.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import BulkActionModal from './bulk-actions/BulkActionModal.vue'
import BulkSubmit from './bulk-actions/BulkSubmit.vue'

const orderRepository = RepositoryFactory.get('order')
const merchantRepository = RepositoryFactory.get('merchant')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
const riderRepository = RepositoryFactory.get('rider')
const ResourceRepository = RepositoryFactory.get('resource')
const waybillSettingsRepository = RepositoryFactory.get('waybillSetting')

export default {
  name: 'KeyCommon',
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    AdvancedDateFilter,
    BAvatar,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardActions,
    FormBuilder,
    BButton,
    BFormGroup,
    BPagination,
    BOverlay,
    OrderStatusBadge,
    BDropdown,
    BDropdownItem,
    BulkActionModal,
    BFormCheckbox,
    ViewOrderModal,
    vSelect,
    FlagDisplay,
    BulkSubmit,
    FilterCard,
    BFormFile,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    status_key: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    date_filter_key: {
      type: String,
      default: 'orders.created_at',
    },
    // eslint-disable-next-line vue/prop-name-casing
    date_filter_name: {
      type: String,
      default: 'Created At',
    },
    // eslint-disable-next-line vue/prop-name-casing
    status_name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Table Info
      freezeWarehouseCheckbox: false,
      submitCount: 0,
      loadingResponse: false,
      avatarText,
      filters: {
        [this.date_filter_key]: {
          startDate: null,
          endDate: null,
        },
      },
      total: 0,
      cod: 0,
      meta: {},
      dataLoading: false,
      sort: '',
      perPage: 20,
      warehouseOptions: [],
      pageOptions: [10, 20, 50, 100, 150, 200],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterName: '',
      fields: [
        {
          key: 'id',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'waybill_number',
          label: 'WayBill Number',
          sortable: true,
        },
        {
          key: 'merchant.name',
          label: 'Merchant',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer Name',
          sortable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'origin_warehouse',
          label: 'Origin',
          sortable: true,
        },
        {
          key: 'destination_warehouse',
          label: 'Destination',
          sortable: true,
        },
        {
          key: 'customer_email',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'rider_name',
          label: 'Rider',
          sortable: true,
        },
        {
          key: 'finance',
          label: 'Finance',
          sortable: false,
        },
        {
          key: 'weight',
          label: 'Net Weight',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'order_flags',
          label: 'Flags',
          sortable: false,
        },
        {
          key: 'status.key',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant.name',
          callback: value => `"${value}"`,
        },
        'Origin City': {
          field: 'origin_city.name',
          callback: value => `"${value}"`,
        },
        'Origin Warehouse': {
          field: 'origin_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Destination City': {
          field: 'destination_city.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod',
        'Collected Cod': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        'Net Weight': 'weight',
        Flag: {
          field: 'order_flags',
          callback: value => {
            const flagNames = value.map(flag => flag.name).join(', ')
            return `"${flagNames}"`
          },
        },
        Status: 'status.name',
      },
      rows: [],
      // Form Info
      formData: {
        proof_files: [],
      },
      assignedwarehouse: [],
      formStructure: [
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Waybill Number',
          value: 'waybill_number',
          class: 'col-12 col-md-3',
          validation: 'required',
        },
      ],
      riderOptions: [],
      merchantOptions: [],
      selectedWaybillArray: [],
      orderSettings: null,
      waybillMaxLength: 0,
      settingWaybillLength: 0,
      auto_submit: false,
      waybillData: [],
      flagData: [],
      selectAllCheckbox: false,
      waybillNumber: '',
      isAutoSubmit: false,
      uploadedImages: [],
      uploadingCount: 0,
      MAX_IMAGES: 4,
      MAX_SIZE_MB: 5,
      ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
      isSubmitting: false,
      filterAuto: true,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    isProofKey() {
      return this.status_key === 'key_6' || this.status_key === 'key_13'
    },
  },
  watch: {
    page() {
      this.getOrderList()
    },
    perPage() {
      this.getOrderList()
    },
    formData: {
      handler(val) {
        const waybill = val.waybill_number
        // eslint-disable-next-line no-empty
        if (waybill.length === this.waybillMaxLength && this.auto_submit) {
          this.onSubmit()
        }
      },
      deep: true,
    },
    loadingResponse(newValue) {
      /* eslint no-underscore-dangle: 0 */
      this.__toggleDisableInput('Waybill Number', newValue)
    },
    waybillData: {
      handler(val) {
        let waybillLocated = false
        val.forEach((data, index) => {
          if (data.waybill_number && this.formData.waybill_number) {
            if (data.waybill_number.toLowerCase() === this.formData.waybill_number.toLowerCase()) {
              waybillLocated = true
              if (!this.formData.weight || (this.waybillData.length > 1 && this.waybillData[index - 1] !== {})) {
                this.$set(this.flagData, 'order_flags', data.order_flags.map(n => n.name) || '')
              }
              this.formKey += 1
              this.inputDisabled = false
              this.$refs.waybill.focus()
            }
          }
        })
        if (!waybillLocated) {
          this.$set(this.flagData, 'order_flags', '')
          this.inputDisabled = true
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.getWarehouseList()
    await this.fetchAssignedWarehouses()
    this.totalRows = this.rows.length
    await this.readOrderSetting()
    await this.getWaybillMaxLength()
    if (this.status_key === 'key_13' || this.status_key === 'key_8') {
      this.getRiderList()
    } else {
      this.fields = this.fields.filter(f => f.key !== 'rider_name')
    }
    if (this.status_key === 'key_19' || this.status_key === 'key_27' || this.status_key === 'key_28') {
      this.getMerchantList()
    }
    if (this.status_key === 'key_19') {
      this.$watch(
        'formData.waybill_number',
        async val => {
          if (val) {
            if (val.length === this.waybillMaxLength) {
              await this.getOrderDetails(val)
            }
          }
        },
      )
    }
  },
  methods: {
    isFreezeWarehouseSelected() {
      return !!this.filters.destination_warehouse
    },
    handleWaybillPaste(pastedText) {
      if (pastedText) {
        if (this.auto_submit) {
          setTimeout(() => {
            this.onSubmit()
          }, 0)
        }
      }
    },
    async getOrderDetails(waybill) {
      try {
        const { data } = (await orderRepository.fetchOrderData(waybill)).data
        this.cod = data.cod
        this.order_merchant_id = data.merchant_id
        this.waybillData.push(data)
      } catch (e) {
        this.showErrorMessage('Check Waybill Number Again, Remove Spaces if there any!')
      }
    },
    async getScanOrderDetails(waybill) {
      if (waybill && this.auto_submit) {
        this.onSubmit()
      }
    },
    async getWarehouseList() {
      try {
        this.warehouseOptions = localStorage.getItem('warehouse_list') ? JSON.parse(localStorage.getItem('warehouse_list')) : (await ResourceRepository.getWarehouseListForDropDown(true)).data.data
        if (!localStorage.getItem('warehouse_list')) localStorage.setItem('warehouse_list', JSON.stringify(this.warehouseOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchAssignedWarehouses() {
      try {
        const { data } = (await ResourceRepository.getAssignedWarehousesNoPagination())
        this.assignedwarehouse = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await orderRepository.getOrderListByKey(this.status_key, this.page, this.perPage, filterQuery))
        this.rows = data.data
        this.meta = data.meta
        this.submitCount = 0
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async getOrderListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await orderRepository.getOrderListByKeyNoPagination(this.status_key, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async readOrderSetting() {
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
        this.settingWaybillLength = this.orderSettings.waybill_setting.auto_waybill_prefix.length + Number(this.orderSettings.waybill_setting.digit_count)
        if (this.orderSettings.waybill_setting.suffix_enabled) this.settingWaybillLength += this.orderSettings.waybill_setting.auto_waybill_suffix.length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getWaybillMaxLength() {
      try {
        const maxWaybill = (await waybillSettingsRepository.getLongestWaybillNumberLength()).data.data
        this.waybillMaxLength = maxWaybill.max_length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getRiderList() {
      this.riderOptions = localStorage.getItem('rider_list') ? JSON.parse(localStorage.getItem('rider_list')) : (await riderRepository.getAllRiderDropDown()).data.data
      if (!localStorage.getItem('rider_list')) localStorage.setItem('rider_list', JSON.stringify(this.riderOptions))
    },
    async getMerchantList() {
      try {
        this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await merchantRepository.getMerchantListForDropdown()).data.data
        if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onSubmit() {
      if (this.isSubmitting) return // Prevent multiple submissions
      this.isSubmitting = true
      try {
        if (this.status_key === 'key_13') {
          await this.showMsgBox()
          if (!this.isDeliveryConfirmed) {
            this.isSubmitting = false
            return
          }
        }
        this.loadingResponse = true
        const formData = new FormData()
        const waybills = this.selectedWaybillArray.length
          ? this.selectedWaybillArray
          : [this.formData.waybill_number]
        waybills.forEach((wb, i) => {
          formData.append(`waybill_numbers[${i}]`, wb)
        })
        formData.append('status_key', this.status_key)
        if (this.status_key === 'key_11') {
          if (this.freezeWarehouseCheckbox === true) {
            formData.append('other_details[warehouse_id]', this.filters.destination_warehouse)
          }
          formData.append('other_details[is_freeze_warehouse]', this.freezeWarehouseCheckbox)
        }
        this.formData.proof_files.forEach((file, index) => {
          formData.append(`proof_files[${index}]`, file)
        })
        await orderRepository.updateOrderStatus(formData)
        this.clearFormData()
        this.showSuccessMessage('Order updated successfully')
        this.submitCount += 1
        this.loadingResponse = false
        this.$nextTick(() => {
          // eslint-disable-next-line no-underscore-dangle
          this.__focusInputField('Waybill Number')
        })
        // }
      } catch (e) {
        this.loadingResponse = false
        this.$nextTick(() => {
          this.clearFormData()
          // eslint-disable-next-line no-underscore-dangle
          this.__focusInputField('Waybill Number')
        })
        this.convertAndNotifyError(e)
      }
      this.isSubmitting = false
    },

    onClickViewOrderModal(id) {
      this.$refs.viewOrderModal.openModal(id)
    },
    onClickBulkAction() {
      this.$refs.bulkActionModal.openModal()
    },
    onClickSelectAll() {
      this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
    },
    onClickDeselctAll() {
      this.selectedWaybillArray = []
    },
    filterQueryUpdate() {
      this.getOrderList()
      this.onClickDeselctAll()
    },
    handleChangePage(page) {
      this.page = page
      this.getOrderList()
    },
    changePage(value) {
      this.perPage = value
    },
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.fetchOrderList()
      }
    },
    onClickRefresh() {
      this.getOrderList()
    },
    async showMsgBox() {
      this.isDeliveryConfirmed = false
      await this.getOrderDetails(this.formData.waybill_number)
      this.cod_display_amount = this.cod
      const formattedAmount = this.cod_display_amount.toLocaleString('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      const dialogText = 'Have you collected the total COD amount ?\n'
      const collectedCODText = `Collected COD: ${formattedAmount}`
      return this.$swal({
        title: 'Confirm Delivery',
        text: dialogText + collectedCODText,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        backdrop: false,
      }).then(value => {
        this.isDeliveryConfirmed = value.isConfirmed
      })
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
      } else {
        this.selectedWaybillArray = []
      }
    },
    clearFormData() {
      this.$refs.formbuilder.reset()
      this.formData.proof_files = []
      this.uploadedImages.forEach(item => item.preview && URL.revokeObjectURL(item.preview))
      this.uploadedImages = []
    },
    onSelectFiles(e) {
      const files = Array.from(e.target.files || [])
      this.handleIncomingFiles(files)
      // reset input so selecting same file again re-triggers change
      e.target.value = ''
    },
    handleIncomingFiles(files) {
      const remaining = this.MAX_IMAGES - this.uploadedImages.length
      if (remaining <= 0) {
        this.showErrorMessage(`You can only upload up to ${this.MAX_IMAGES} images.`)
        return
      }
      const take = files.slice(0, remaining)
      take.forEach(file => {
        if (!this.ALLOWED_TYPES.includes(file.type)) {
          this.showErrorMessage('Only jpeg, png, or webp files are allowed.')
          return
        }
        if (file.size > this.MAX_SIZE_MB * 1024 * 1024) {
          this.showErrorMessage(`File too large. Max ${this.MAX_SIZE_MB} MB.`)
          return
        }
        this.formData.proof_files.push(file)
        const localId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
        const preview = URL.createObjectURL(file)
        this.uploadedImages.push({
          localId,
          file,
          name: file.name,
          preview,
          status: 'ready',
          url: null,
        })
      })
    },
    removeImage(index) {
      const item = this.uploadedImages[index]
      if (item?.preview) URL.revokeObjectURL(item.preview)
      this.uploadedImages.splice(index, 1)
      this.formData.proof_files.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../@core/scss/vue/pages/proof-doc-upload.scss';
.per-page-selector {
    width: 125px;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .per-page-selector {
    width: 200px; /* Shrinks in tablet view */
  }
}
</style>
